import { IFontPresents, TFontPreset, TView } from './models';

// Совпадает с дефолтом в файле styles.css
export const defaultFontSize = 16;
export const defaultLineHeight = 1.4;
export const defaultFontWeight = 4;
export const defaultTheme = 'light';

export const viewMap: Record<TView, TFontPreset> = {
    component: 'component',
    'component-secondary': 'component-secondary',
    caps: 'caps',
    'primary-large': 'primaryLarge',
    'primary-medium': 'primaryNormal',
    'primary-small': 'primarySmall',
    'secondary-large': 'secondaryLarge',
    'secondary-medium': 'secondaryNormal',
    'secondary-small': 'secondarySmall',
    xlarge: 'systemXLarge',
    large: 'systemLarge',
    medium: 'systemNormal',
    small: 'systemSmall',
    xsmall: 'systemXSmall',
};

export const fontPresets: IFontPresents = {
    // Text
    primaryLarge: {
        // @mixin paragraph_primary_large;
        fontSize: 18,
        lineHeight: 24,
        fontWeight: 4,
    },
    primaryNormal: {
        // @mixin paragraph_primary_normal;
        fontSize: 16,
        lineHeight: 24,
        fontWeight: 4,
    },
    primarySmall: {
        // @mixin paragraph_primary_small;
        fontSize: 14,
        lineHeight: 20,
        fontWeight: 4,
    },
    secondaryLarge: {
        // @mixin paragraph_secondary_large;
        fontSize: 13,
        lineHeight: 16,
        fontWeight: 4,
    },
    secondaryNormal: {
        // @mixin paragraph_secondary_normal;
        fontSize: 12,
        lineHeight: 16,
        fontWeight: 4,
    },
    secondarySmall: {
        //  @mixin paragraph_secondary_small;
        fontSize: 11,
        lineHeight: 16,
        fontWeight: 4,
    },
    component: {
        fontSize: 16,
        lineHeight: 20,
        fontWeight: 4,
    },
    'component-secondary': {
        fontSize: 14,
        lineHeight: 18,
        fontWeight: 4,
    },
    caps: {
        fontSize: 12,
        lineHeight: 16,
        fontWeight: 5,
        letterSpacing: 125,
        textTransform: 'uppercase',
    },
    // Title styrene
    styreneXLarge: {
        // @mixin headline_xlarge;
        fontSize: 48,
        lineHeight: 64,
        fontWeight: 5,
    },
    styreneLarge: {
        // @mixin headline_large;
        fontSize: 40,
        lineHeight: 48,
        fontWeight: 5,
    },
    styreneNormal: {
        // @mixin headline_normal;
        fontSize: 32,
        lineHeight: 40,
        fontWeight: 5,
    },
    styreneSmall: {
        // @mixin headline_small;
        fontSize: 24,
        lineHeight: 32,
        fontWeight: 5,
    },
    styreneXSmall: {
        // @mixin headline_xsmall;
        fontSize: 20,
        lineHeight: 24,
        fontWeight: 5,
    },
    // Title system
    systemXLarge: {
        // @mixin headline-system_xlarge;
        fontSize: 48,
        lineHeight: 52,
        fontWeight: 7,
    },
    systemLarge: {
        // @mixin headline-system_large;
        fontSize: 40,
        lineHeight: 48,
        fontWeight: 7,
    },
    systemNormal: {
        // @mixin headline-system_normal;
        fontSize: 30,
        lineHeight: 36,
        fontWeight: 7,
    },
    systemSmall: {
        // @mixin headline-system_small;
        fontSize: 22,
        lineHeight: 26,
        fontWeight: 7,
    },
    systemXSmall: {
        // @mixin headline-system_xsmall;
        fontSize: 18,
        lineHeight: 22,
        fontWeight: 7,
    },
};

export const lineHeights = [16, 18, 20, 22, 24, 26, 32, 36, 40, 48, 52, 64];
